var _defs, _path, _polygon, _polygon2, _polygon3, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCryptohall24(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 2711.8 564.8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".c{fill:#fff;}.d{fill:#e7ff06;}.e{fill:url(#b);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 0,
    y1: 284.2,
    x2: 540,
    y2: 284.2,
    gradientTransform: "translate(0 566.6) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c100fb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6b00cd"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M540,136.7v219l-82,53-.5-218.5-173.5-98.9L124.7,194.1l173.6,98.8v219l-5.2,3.4-76.8,49.6v-219l-134.4-76.5-61.5-35C7.7,227.1,.8,214.4,0,201.5v-2.6H.1c0-12.8,5.7-25.7,17.8-33.9l11.6-7.8L260.7,7.8c15.3-9.9,34.8-10.4,50.6-1.4l228.6,130.3Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "c",
    points: "216.4 469.2 216.4 564.8 82 484.1 0 434.9 0 339.3 82 388.5 216.4 469.2"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "c",
    points: "419.9 432.7 338 485.7 337.6 267.2 337.5 267.2 202 189.7 283.9 136.8 419.4 214.2 419.9 432.7"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "d",
    points: "335.2 269.1 335.2 269.2 335.1 269.2 335.2 269.1"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M851,327.9v14.2c0,33-7,75.2-76.1,75.2s-73.2-23.6-73.2-71.7V217.1c0-45.5,26.2-69.5,74.5-69.5s74,36.4,74,70.7v16.4h-58.4v-22.3c0-14.4-3.5-21.7-15.7-21.7s-15.8,6.9-15.8,21.7v138.4c0,14,2.7,23.5,15.8,23.5s16.3-8,16.3-24.7v-21.8h58.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M934.2,299.5v113.8h-57.9V151.5h75.2c50.5,0,75.5,19.3,75.5,65.1v9.4c0,37.3-17.2,48.4-30.1,53.7,18.8,7.9,27.6,19.8,27.6,56.4s-.4,63.5,2.1,77.2h-56.1c-3.8-11.8-3.5-45.9-3.5-79.3s-3.9-34.5-26-34.5h-6.8Zm.2-39.7h7.2c19.4,0,27.3-5.3,27.3-29.7v-12.6c0-17.6-4.1-26.3-25.4-26.3h-9v68.6h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M1092.8,413.3v-83.8c0-4.2-.8-8.9-2.1-13.5l-53-164.4h63.2c8.1,37.8,17.6,81.1,21.3,114.1h1.9c4.9-31.3,14.6-75.6,22.4-114.1h59.8l-54.2,168.6c-.8,3.2-1.4,5.8-1.4,11.3v81.9h-57.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M1221.1,151.5h77.3c50.1,0,74.9,23,74.9,69.4v16c0,45.9-19.9,73.5-77.1,73.5h-17v102.9h-58.1V151.5Zm58.1,118.1h9.4c22,0,26.7-10.7,26.7-32.5v-18.1c0-16.9-4.6-27.8-23.9-27.8h-12.2v78.4h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M1430.6,196h-43.9v-44.5h146v44.5h-44.2v217.3h-57.9V196h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M1704.2,221.6v121.4c0,51.9-28.2,74.2-80.9,74.2s-75.7-22.8-75.7-73.7v-123.3c0-50.5,32-72.6,78.4-72.6,46.7,0,78.2,21.7,78.2,74Zm-98-5.7v133.8c0,16.2,6.4,24.6,19.3,24.6s19.6-7.6,19.6-24.9V215.5c0-16.4-5.2-24.7-19.8-24.7s-19.2,7.7-19.2,25.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M1735.4,151.5h58.1v100.8h37.8v-100.8h58.4V413.3h-58.4v-116.6h-37.8v116.6h-58.1V151.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M1977.7,351l-7.4,62.3h-59.1l42.6-261.8h86.5l43.6,261.8h-60.3l-8.3-62.3h-37.6Zm32.6-44.4c-4.3-33.5-10.3-84.4-13.1-109.5h-2.3c-1,18.2-8.2,77.1-12.2,109.5h27.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M2104.6,151.5h58.1v217.7h72.9l-5.2,44h-125.8V151.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M2253.7,151.5h58.1v217.7h72.9l-5.2,44h-125.8V151.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M2394.8,413.3v-4.5c.3-51.1,15.2-76.6,49.1-119.4,30.3-38.7,36-48,36-74.2s-1.6-26.4-15.2-26.4-16.4,8.8-16.4,24.1v17h-53.8v-15.6c0-29.8,10.8-66.2,72.4-66.2s71.7,30.8,71.7,68.2-10.6,52.3-44.1,94.5c-16.6,20.9-31.2,40.5-33.2,59.3h83.6l-7.4,43.2h-142.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M2638.8,413.3v-60.7h-83.8v-39.4l55.4-161.7h82.6v159.6h18.9l-3.8,41.6h-15.1v60.7h-54.1Zm0-137.4c0-28.9,1.7-59.2,2.6-82.5h-1.1c-9.2,34.9-21.9,84.2-32.2,117.6h30.7v-35.2Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCryptohall24);
export default __webpack_public_path__ + "static/media/cryptohall24.c52308029ac5e3a1dadfc5843d8e688c.svg";
export { ForwardRef as ReactComponent };